import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class TableDataService {

  /**
   * 
   * @param http 
   */
  constructor(private http: HttpClient) { }

  /**
   * 
   * @param code
   * @param params 
   * @param serviceOptions
   */
  public viewData(code: string, params: any = undefined, serviceOptions: ITableDataServiceOptions = undefined): Observable<ITableDataResponse> {
    return this.tableDataGetImpl(code, 'view', params, undefined, serviceOptions);
  }

  /**
   * 
   * @param code 
   * @param params 
   * @param serviceOptions
   */
  public exportData(code: string, params: any = undefined, serviceOptions: ITableDataServiceOptions = undefined): Observable<Blob> {
    const request: ITableDataRequest = {
      code: code,
      action: 'export',
      jsonParams: JSON.stringify(params),
      externalLoginTicket: serviceOptions?.externalLoginTicket
    };
    
    return this.http.post(this.url(serviceOptions?.controller), request, { responseType: 'blob' });    
  }

  /**
   * 
   * @param code 
   * @param emailAddress 
   * @param params 
   * @param serviceOptions
   */
  public emailData(code: string, emailAddress: string, params: any = undefined, serviceOptions: ITableDataServiceOptions = undefined): Observable<ITableDataResponse> {
    return this.tableDataGetImpl(code, 'email', params, { emailAddress: emailAddress }, serviceOptions);
  }

  /**
 * 
 * @param code 
 * @param serviceOptions
 */
  public getDefinition(code: string, serviceOptions: ITableDataServiceOptions = undefined): Observable<ITableDataDefResponse> {
    return this.tableDataGetImpl(code, 'definition', undefined, undefined, serviceOptions);
  }

  /**
   * 
   */
  private url(controller: string = undefined): string {
    const ret = `${environment.scApiProtocol}://${environment.scApiHost}:${environment.scApiPort}/api/${controller || 'SantaCruz'}/TableDataGet`;
    return ret;
  }

  /**
   * @param code
   * @param action
   * @param params 
   * @param actionData
   * @param hostOptions
   */
  private tableDataGetImpl<typeOfResponse extends IResopnseBasic>(code: string, action: string, params: any = undefined, actionData: any = undefined, hostOptions: ITableDataServiceOptions = undefined): Observable<typeOfResponse> {
    
    const request: ITableDataRequest = {
      code: code,
      action: action,
      jsonActionData: JSON.stringify(actionData),
      jsonParams: JSON.stringify(params),
      externalLoginTicket: hostOptions?.externalLoginTicket
    };

    
    const loader$ = this.http.post<typeOfResponse>(this.url(hostOptions?.controller), request).pipe(
      tap(v => {
        if (!v.success)
          throw v;
      }),
    );
    return loader$;
  }

  /**
   * 
   */
  public getGroups(): Observable<ITableDataGroupsGetResponse> {
    const loader$ = this.http.get<ITableDataGroupsGetResponse>(`${environment.scApiProtocol}://${environment.scApiHost}:${environment.scApiPort}/api/SantaCruz/TableDataGroupsGet`).pipe(
      tap(v => {
        if (!v.success)
          throw v;
      }),
    );
    return loader$;
  }

}

export interface ITableDataGroupsGetResponse extends IResopnseBasic {
  groups: ITableDataGroup[];
}

export interface ITableDataGroup {
  title: string;
  items: ITableDatsGroupItem[];

}

export interface ITableDatsGroupItem {
  code: string;
  title: string;
}

export interface IResopnseBasic {
  success: boolean;
  message: string;
}

interface ITableDataRequest {
  code: string;

  action: string;
  jsonActionData?: any;

  jsonParams?: any;

  externalLoginTicket?: string;
}

export interface ITableDataResponse extends IResopnseBasic {
  dataLimitMessage?: string;
  columns: string[];
  rows: string[][];
}

export interface ITableDataDefResponse extends IResopnseBasic {
  code: string;
  title: string;
  zipFileName: string;

  collectReasons: boolean;
  reasonQuestions: string[];

  defs: IParamEntryItemDef[];
}

export interface IParamEntryItemDef {
  code: string;
  description: string;
  helpText: string;
  required: boolean;

  entryType: string /* input, select, checkbox */
  selectItems?: { value: string, label: string }[]
  inputType?: string;

}

export interface ITableDataServiceOptions {
  controller: string;
  externalLoginTicket: string;
}